<template>
    <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 95vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">Mapping DIPA iemon</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <p>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="table-responsive table-wrapper">
                                <table class="table m-0" id="tabeldata" style="font-size: x-small;">
                                    <thead>
                                        <tr>
                                            <th style="width: 50px;" v-if="showNo">No</th>
                                            <th style="width: 50px;" v-if="showKode">Kode</th>
                                            <th style="width: 100px;" v-if="showKegiatan">Kegiatan/KRO/Nominal (Rp.)
                                            </th>
                                            <th style="width: 50px;" v-if="showKode">Kode Program</th>
                                            <th style="width: 50px;" v-if="showKode">Kode Kegiatan</th>
                                            <th style="width: 50px;" v-if="showKode">Kode Output</th>
                                            <th style="width: 50px;" v-if="showKode">BA</th>
                                            <th style="width: 50px;" v-if="showKode">Baes</th>
                                            <th style="width: 50px;" v-if="showKode">Akun</th>
                                            <th style="width: 50px;" v-if="showKode">Kewenangan</th>
                                            <th style="width: 50px;" v-if="showKode">Sumber Dana</th>
                                            <th style="width: 50px;" v-if="showKode">Lokasi</th>
                                            <th style="width: 50px;" v-if="showKode">Tipe Budget</th>
                                            <th style="width: 50px;" v-if="showKode">Cara Tarik</th>
                                        </tr>
                                    </thead>
                                    <template v-for="(datalist, urutlist) in dataemon" :key="urutlist">
                                        <tbody>
                                            <tr>
                                                <td class="text-center" :class="datalist.class" v-if="showNo">
                                                    <span v-if="urutlist > 0 && datalist.class == 'akhirbaru'">
                                                        <input type="checkbox" :checked="datalist.terpilih == 'true'"
                                                            @click="cekarray()" :id="'checkbox' + urutlist">
                                                    </span>
                                                </td>
                                                <td class="text-left" :class="datalist.class" v-if="showKode">
                                                    {{ datalist.kdgiat }}
                                                </td>
                                                <td class="text-left" :class="datalist.class" v-if="showKegiatan"
                                                    :colspan="[datalist.class != 'akhirbaru' ? '12' : '']">
                                                    <span v-if="datalist.class != 'akhirbaru'">{{ datalist.nmgiat
                                                        }}</span>
                                                    <span v-else>{{ (datalist.amount) }}</span>
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.program }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.kegiatan }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.kdoutput }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.ba }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.baes1 }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.akun }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.kewenangan }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.sumber_dana }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.lokasi }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.budget_type }}
                                                </td>
                                                <td class="text-left" :class="datalist.class"
                                                    v-if="datalist.class == 'akhirbaru'">
                                                    {{ datalist.cara_tarik }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <tbody v-if="(datapesan == 'data kosong')">
                                        <tr>
                                            <td colspan="3">Data masih kosong</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                    </div>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-success3 btn-sm lebar2 text-white" data-dismiss="modal"><i
                            class="fas fa-plus-square"></i>
                        Pilih</button>
                    <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" @click="loading()"> <i
                            class="far fa-times-circle"></i>
                        Batal</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="javascript:void(0)"
                                        @click="batalproses()">Finance</a>
                                </li>
                                <li class="breadcrumb-item active">Pengaturan DIPA</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Pengaturan DIPA</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="card card-success collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">INFORMASI PAKET PEKERJAAN</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-12 float-left">
                                                            <label>PIU <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="id_user" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedid_user"
                                                                @update:modelValue="onid_userChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-12 float-left">
                                                            <label>Satker <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="satker" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedsatker"
                                                                @update:modelValue="onsatkerChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left" style="display: none;">
                                                            <label>Nama Kegiatan PMIS <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="idpmis" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedidpmis"
                                                                @update:modelValue="onidpmisChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6">
                                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nama_Kegiatan" name="Nama_Kegiatan"
                                                                    placeholder="Nama Kegiatan" v-model="Nama_Kegiatan"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Lokasi<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="lokasi" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedlokasi"
                                                                @update:modelValue="onlokasiChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Komponen / Output<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Komponen" name="Komponen" placeholder="Komponen"
                                                                    v-model="Komponen" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Sub Komponen<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="SubKomponen" name="SubKomponen"
                                                                    placeholder="Sub Komponen" v-model="SubKomponen"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Jenis Pekerjaan <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="jenispekerjaan"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedjenispekerjaan"
                                                                @update:modelValue="onjenispekerjaanChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Bank Review <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="bankreview"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedbankreview"
                                                                @update:modelValue="onbankreviewChange"
                                                                style="background-color: #ffffff;" disabled></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6">
                                                            <label>Penyedia<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Penyedia" name="Penyedia" placeholder="Penyedia"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nilai Kontrak (Rp.)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nilai" name="Nilai" placeholder="Nilai Kontrak"
                                                                    @keyup="formattulisrupiah('Nilai')"
                                                                    @keydown="formattulisrupiah('Nilai')" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Mulai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Mulai" name="Mulai" placeholder="Mulai Kontrak"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Selesai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Selesai" name="Selesai"
                                                                    placeholder="Selesai Kontrak" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nomor Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Kontrak" name="Kontrak"
                                                                    placeholder="Nomor Kontrak" disabled>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Adendum</label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Adendum" name="Adendum" placeholder="Adendum"
                                                                    disabled>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-pink collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">REKAPITULASI DIPA</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in DIPA" :key="urutdata"
                                                            v-if="secretencData != 'Tambah'">
                                                            <label>DIPA {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'DIPA' + datadata.Tahun"
                                                                    :name="'DIPA' + datadata.Tahun" placeholder="DIPA"
                                                                    :value="G_numFormat(datadata.Nilai)"
                                                                    :disabled="roleuser != 'admin'"
                                                                    @keyup="formattulisrupiah('DIPA' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('DIPA' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in DIPA" :key="urutdata"
                                                            v-if="secretencData == 'Tambah'">
                                                            <label>DIPA {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'DIPA' + datadata.Tahun"
                                                                    :name="'DIPA' + datadata.Tahun" placeholder="DIPA"
                                                                    value="0" :disabled="roleuser != 'admin'"
                                                                    @keyup="formattulisrupiah('DIPA' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('DIPA' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-teal">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">DETAIL DIPA</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-minus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-12 text-center">
                                                            <div class="col-sm-12 text-center">
                                                                <button type="button"
                                                                    class="btn btn-sm btn-success text-white lebar2"
                                                                    @click="mapping(selectedsatker)"
                                                                    data-toggle="tooltip" data-placement="left"
                                                                    title="Mapping DIPA.."><i
                                                                        class="fa fa-check-circle"></i>
                                                                    Mapping DIPA</button>
                                                            </div>
                                                            <div class="col-sm-12 text-center">&nbsp;</div>
                                                            <div class="table-responsive table-wrapper">
                                                                <table class="table m-0" id="tabeldata"
                                                                    style="font-size: x-small;">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style="width: 50px;">
                                                                                Opsi
                                                                                <button type="button"
                                                                                    class="btn btn-success btn-sm"
                                                                                    @click="addDIPA"
                                                                                    v-if="datadetail.length == 0"><i
                                                                                        class="far fa-plus-square"></i></button>
                                                                            </th>
                                                                            <th style="width: 50px;">No</th>
                                                                            <th style="width: 120px;">Kode Program</th>
                                                                            <th style="width: 120px;">Kode Kegiatan</th>
                                                                            <th style="width: 120px;">Kode Ouput</th>
                                                                            <th style="width: 120px;">BA</th>
                                                                            <th style="width: 120px;">Baes</th>
                                                                            <th style="width: 120px;">Akun</th>
                                                                            <th style="width: 120px;">Nomimal (Rp.)</th>
                                                                            <th style="width: 120px;">Kewenangan</th>
                                                                            <th style="width: 120px;">Sumber Dana</th>
                                                                            <th style="width: 120px;">Lokasi</th>
                                                                            <th style="width: 120px;">Tipe Bugdet</th>
                                                                            <th style="width: 120px;">Cara Tarik</th>
                                                                            <th style="width: 120px;">Kode Register</th>
                                                                            <th style="width: 250px;">Dokumen</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <template v-for="(datalist, urutlist) in datadetail"
                                                                        :key="urutlist">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <div class="col-sm-12 text-center">
                                                                                        <button type="button"
                                                                                            class="btn btn-success btn-sm"
                                                                                            @click="addDIPA"><i
                                                                                                class="far fa-plus-square"></i></button>
                                                                                        <button type="button"
                                                                                            class="btn btn-warning btn-sm"
                                                                                            @click="deleteDIPA(urutlist)"
                                                                                            v-if="(datadetail.length > 0)"><i
                                                                                                class="far fa-minus-square"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    {{ urutlist + 1 }}
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'program' + (urutlist + 1)"
                                                                                        :name="'program' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Program'"
                                                                                        v-model="datalist.program">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'kegiatan' + (urutlist + 1)"
                                                                                        :name="'kegiatan' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Kegiatan'"
                                                                                        v-model="datalist.kegiatan">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'kdoutput' + (urutlist + 1)"
                                                                                        :name="'kdoutput' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Kode Output'"
                                                                                        v-model="datalist.kdoutput">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'ba' + (urutlist + 1)"
                                                                                        :name="'ba' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'BA'"
                                                                                        v-model="datalist.ba">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'baes1' + (urutlist + 1)"
                                                                                        :name="'baes1' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Baes'"
                                                                                        v-model="datalist.baes1">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'akun' + (urutlist + 1)"
                                                                                        :name="'akun' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Akun'"
                                                                                        v-model="datalist.akun">
                                                                                </td>
                                                                                <td class="text-right">
                                                                                    <input type="text"
                                                                                        :id="'amount' + (urutlist + 1)"
                                                                                        :name="'amount' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Nilai'"
                                                                                        v-model="datalist.amount"
                                                                                        @keyup="formattulisrupiah('amount' + (urutlist + 1))"
                                                                                        @keydown="formattulisrupiah('amount' + (urutlist + 1))">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'kewenangan' + (urutlist + 1)"
                                                                                        :name="'kewenangan' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Kewenangan'"
                                                                                        v-model="datalist.kewenangan">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'sumber_dana' + (urutlist + 1)"
                                                                                        :name="'sumber_dana' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Sumber Dana'"
                                                                                        v-model="datalist.sumber_dana">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'lokasi' + (urutlist + 1)"
                                                                                        :name="'lokasi' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Lokasi'"
                                                                                        v-model="datalist.lokasi">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'budget_type' + (urutlist + 1)"
                                                                                        :name="'budget_type' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Tipe'"
                                                                                        v-model="datalist.budget_type">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'cara_tarik' + (urutlist + 1)"
                                                                                        :name="'cara_tarik' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Cara Tarik'"
                                                                                        v-model="datalist.cara_tarik">
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    <input type="text"
                                                                                        :id="'kdregister' + (urutlist + 1)"
                                                                                        :name="'kdregister' + (urutlist + 1)"
                                                                                        class="form-control form-control-sm"
                                                                                        :placeholder="'Register'"
                                                                                        v-model="datalist.kdregister">
                                                                                </td>
                                                                                <td class="text-left">
                                                                                    <a :href="folder_foto + datalist.filenya_dipa"
                                                                                        target="_blank"
                                                                                        v-if="datalist.filenya_dipa != '' && datalist.filenya_dipa != null">Lihat
                                                                                        Dokumen</a>
                                                                                    <input type="hidden"
                                                                                        class="form-control form-control-sm"
                                                                                        :id="'filenya_dipa' + (urutlist + 1)"
                                                                                        :name="'filenya_dipa' + (urutlist + 1)"
                                                                                        placeholder="Dokument" readonly
                                                                                        :value="(datalist.filenya_dipa)">
                                                                                    <input type="file"
                                                                                        class="form-control form-control-sm"
                                                                                        :id="'fileToUploadfilenya_dipa' + (urutlist + 1)"
                                                                                        :name="'fileToUploadfilenya_dipa' + (urutlist + 1)"
                                                                                        placeholder="fileToUpload"
                                                                                        style="font-size: smaller;"
                                                                                        accept="application/pdf">
                                                                                    <br>
                                                                                    <div class="progress">
                                                                                        <div class="progress-bar"
                                                                                            role="progressbar"
                                                                                            aria-valuenow="0"
                                                                                            aria-valuemin="0"
                                                                                            aria-valuemax="100"
                                                                                            style="width:0%"
                                                                                            :id="'persennyafilenya_dipa' + (urutlist + 1)">
                                                                                            <span
                                                                                                :id="'tulisanpersenfilenya_dipa' + (urutlist + 1)">0%</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <br>
                                                                                    <span class="text-success"
                                                                                        :id="'suksesnyafilenya_dipa' + (urutlist + 1)"></span>
                                                                                    <br>
                                                                                    <button type="button"
                                                                                        class="btn btn-warning btn-sm lebar text-white"
                                                                                        @click="uploadfiledetail('filenya_dipa' + (urutlist + 1), 'application/pdf')">Upload
                                                                                        File</button>
                                                                                    <button type="button"
                                                                                        class="btn btn-danger btn-sm lebar"
                                                                                        @click="clearfilepetadetail('filenya_dipa' + (urutlist + 1))">Hapus
                                                                                        File</button>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </template>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Batal</button>
                                </div>
                                <div class="card-footer p-3">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            Komponen: '',
            SubKomponen: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,

            idpmis: [],
            dataidpmis: [],
            defaultSelectedidpmis: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedidpmis: 0,

            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: 0,

            Penyedia: '',
            Mulai: '',
            Selesai: '',
            Kontrak: 0,
            Nilai: 0,
            Adendum: '',
            OWP: '',
            OWPEmon: '',
            AWP: [],
            AWPEmon: [],
            DIPA: [],
            DIPAEmon: [],
            REALISASI: [],
            Target: 0,
            Capaian: 0,
            Realisasi: 0,
            TanggalData: new Date(),
            Keterangan: '',
            tahapanpekerjaan: [],
            filenya_tahapan: '',
            LATITUDE: '',
            LONGITUDE: '',
            kendala: '',
            tindaklanjut: '',
            validasi: false,

            satker: [],
            datasatker: [],
            defaultSelectedsatker: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '0',
            },
            selectedsatker: '0',

            bankreview: [],
            databankreview: [],
            defaultSelectedbankreview: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedbankreview: '',

            bankreview: [],
            databankreview: [],
            defaultSelectedbankreview: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedbankreview: '',

            Screening_Form: [],
            dataScreening_Form: [],
            defaultSelectedScreening_Form: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedScreening_Form: '',
            Environmental_Permit: [],
            dataEnvironmental_Permit: [],
            defaultSelectedEnvironmental_Permit: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedEnvironmental_Permit: '',
            Environmental_Doucument: '',
            Permit_Date: '',
            SupplementaryDocumentDate: '',

            SupplementaryDocumentStatus: [],
            dataSupplementaryDocumentStatus: [],
            defaultSelectedSupplementaryDocumentStatus: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedSupplementaryDocumentStatus: '',

            C_EMP_Date: '',
            C_EMP_Status: [],
            dataC_EMP_Status: [],
            defaultSelectedC_EMP_Status: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedC_EMP_Status: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovationdipa-PDF?f=',

            filenya_dipa: '',
            koderegister: '',
            kodeemon: [],
            paketemon: [],
            dataemon: [],
            showNo: true,
            showKode: true,
            showKegiatan: true,
            showSatuan: false,
            showVolume: false,
            showLokasi: false,
            showJenisPaket: false,
            showMetode: false,
            showSumberDana: false,
            showPagu: true,
            showRealisasi: true,
            showKeu: true,
            showFisik: true,
            showPaguE: true,
            showKeuE: true,
            showFisikE: true,
            counterDIPA: 0,
            datadetail: [],
        }
    },
    methods: {
        addDIPA() {
            this.datadetail.push({
                "kdsatker": this.selectedsatker,
                "ba": '',
                "baes1": '',
                "akun": '',
                "program": '',
                "kegiatan": '',
                "kdoutput": '',
                "kewenangan": '',
                "sumber_dana": '',
                "lokasi": '',
                "budget_type": '',
                "amount": 0,
                "cara_tarik": '',
                "kdregister": '',
            })
            this.counterDIPA = this.counterDIPA + 1;
        },
        deleteDIPA(counterDIPA) {
            this.datadetail.splice(counterDIPA, 1);
        },
        loading() {
            document.location.reload();
        },
        cekarray() {
            var tempdatadetail = this.dataemon;
            this.datadetail = [];
            //alert(tempdatadetail.length);
            //console.log(tempdatadetail);
            //return;
            for (let i = 0; i < tempdatadetail.length; i++) {
                if (tempdatadetail[i].class == 'akhirbaru') {
                    if (document.getElementById('checkbox' + i).checked == true) {
                        this.datadetail.push({
                            "idnya": tempdatadetail[i].idnya,
                            "kdsatker": tempdatadetail[i].kdsatker,
                            "ba": tempdatadetail[i].ba,
                            "baes1": tempdatadetail[i].baes1,
                            "akun": tempdatadetail[i].akun,
                            "program": tempdatadetail[i].program,
                            "kegiatan": tempdatadetail[i].kegiatan,
                            "kdoutput": tempdatadetail[i].kdoutput,
                            "kewenangan": tempdatadetail[i].kewenangan,
                            "sumber_dana": tempdatadetail[i].sumber_dana,
                            "lokasi": tempdatadetail[i].lokasi,
                            "budget_type": tempdatadetail[i].budget_type,
                            "amount": tempdatadetail[i].amount,
                            "cara_tarik": tempdatadetail[i].cara_tarik,
                            "kdregister": tempdatadetail[i].kdregister,
                            "class": tempdatadetail[i].class,
                        });
                    }
                }
            }
        },
        async mapping(kodesatker) {
            this.kodeemon = [];
            this.halamanloading = true;
            //alert(kodesatker);
            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            //alert(terpilih);
            //alert(this.koderegister);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.idkegiatan);
            await mainAPI.get("detaildipa_emon-DIPA?random=" + random + "&project_id=" + this.project_id + "&id=" + terpilih
                + "&kode_satker=" + kodesatker + "&koderegister=" + this.koderegister).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.dataemon = [];
                            this.kodeemon = [];
                            this.dataemon = Response.data.content.data;
                            //console.log(this.dataemon);
                            for (let i = 0; i < this.dataemon.length; i++) {
                                if (this.dataemon[i].terpilih == 'true') {
                                    this.kodeemon.push(this.dataemon[i].idnya + this.dataemon[i].kdsatker + this.dataemon[i].ba + this.dataemon[i].baes1 + this.dataemon[i].akun + this.dataemon[i].program + this.dataemon[i].kegiatan + this.dataemon[i].kdoutput + this.dataemon[i].kewenangan + this.dataemon[i].sumber_dana + this.dataemon[i].lokasi + this.dataemon[i].budget_type + this.dataemon[i].amount + this.dataemon[i].cara_tarik + this.dataemon[i].kdregister);
                                }
                            }
                            $('#costumModalpeta').modal('show');
                            this.halamanloading = false;
                        }
                        else {
                            this.dataemon = [];
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    this.dataemon = [];
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });
        },
        cekisi(isinya) {
            //alert(document.getElementById(isinya).value);
        },
        rubahowp(kode) {
            this.OWP = document.getElementById(kode).value;
        },
        rubahsinkronisasi(awal, akhir) {
            document.getElementById(akhir).value = document.getElementById(awal).value;
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        uploadfiledetail(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", 'filenya_dipa');
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepetadetail(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", 'filenya_dipa');
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },

        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            if (this.roleuser == 'user') {
                var idadi = this.levelinstansi;
            }
            else {
                var idadi = '';
            }

            mainAPI5.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + idadi).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasatker = [];
                        this.satker = [];
                        this.datasatker = Response.data.content.data;
                        this.datasatker.forEach((item) => {
                            this.satker.push({
                                label: item.namasatker,
                                code: this.datasatker.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.satker.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '0',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            await mainAPI5.get("parastapainnovation_bankreview-Data?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.databankreview = [];
                        this.bankreview = [];
                        this.databankreview = Response.data.content.data;
                        this.databankreview.forEach((item) => {
                            this.bankreview.push({
                                label: item.nama,
                                code: this.databankreview.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bankreview.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            await mainAPI5.get("parastapainnovationenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataScreening_Form = [];
                        this.Screening_Form = [];
                        this.dataScreening_Form = Response.data.content.data;
                        this.dataScreening_Form.forEach((item) => {
                            this.Screening_Form.push({
                                label: item.nama,
                                code: this.dataScreening_Form.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Screening_Form.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataC_EMP_Status = [];
                        this.C_EMP_Status = [];
                        this.dataC_EMP_Status = Response.data.content.data;
                        this.dataC_EMP_Status.forEach((item) => {
                            this.C_EMP_Status.push({
                                label: item.nama,
                                code: this.dataC_EMP_Status.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.C_EMP_Status.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataEnvironmental_Permit = [];
                        this.Environmental_Permit = [];
                        this.dataEnvironmental_Permit = Response.data.content.data;
                        this.dataEnvironmental_Permit.forEach((item) => {
                            this.Environmental_Permit.push({
                                label: item.nama,
                                code: this.dataEnvironmental_Permit.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Environmental_Permit.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationenv-NOL?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSupplementaryDocumentStatus = [];
                        this.SupplementaryDocumentStatus = [];
                        this.dataSupplementaryDocumentStatus = Response.data.content.data;
                        this.dataSupplementaryDocumentStatus.forEach((item) => {
                            this.SupplementaryDocumentStatus.push({
                                label: item.nama,
                                code: this.dataSupplementaryDocumentStatus.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.SupplementaryDocumentStatus.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_tahapanpekerjaan-GetTahapanPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataStatus_pekerjaan = [];
                        this.Status_pekerjaan = [];
                        this.dataStatus_pekerjaan = Response.data.content.data;
                        this.dataStatus_pekerjaan.forEach((item) => {
                            this.Status_pekerjaan.push({
                                label: item.nama,
                                code: this.dataStatus_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Status_pekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.pilihKegiatanPMIS();
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilTahapanPekerjaan();

            //alert(this.selectedjenispekerjaan);
        },
        onbankreviewChange(a) {
            try {
                this.selectedbankreview = this.bankreview[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onScreening_FormChange(a) {
            try {
                this.selectedScreening_Form = this.Screening_Form[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onC_EMP_StatusChange(a) {
            try {
                this.selectedC_EMP_Status = this.C_EMP_Status[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onEnvironmental_PermitChange(a) {
            try {
                this.selectedEnvironmental_Permit = this.Environmental_Permit[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onSupplementaryDocumentStatusChange(a) {
            try {
                this.selectedSupplementaryDocumentStatus = this.SupplementaryDocumentStatus[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onidpmisChange(a) {
            try {
                this.selectedidpmis = this.idpmis[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Finance/" + kode);
        },
        async AmbilTahapanPekerjaan() {
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.tahapanpekerjaan = [];
            await mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + this.selectedjenispekerjaan + "&id_kegiatan=" + this.secretencData).then(
                Responsecari => {
                    this.tahapanpekerjaan = Responsecari.data.content.data;
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async pilihKegiatanPMIS() {
            this.halamanloading = true;
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                Responsecari => {
                    this.dataidpmis = [];
                    this.idpmis = [];
                    this.dataidpmis = Responsecari.data.content.data;
                    this.dataidpmis.forEach((item) => {
                        this.idpmis.push({
                            label: item.nama_kegiatan,
                            code: this.dataidpmis.indexOf(item) + 1,
                            tag: item.id_kegiatan,
                        });
                    });
                    this.idpmis.unshift({
                        label: 'Pilih Salah Satu',
                        code: 0,
                        tag: '',
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        async AmbilDataSingel() {
            //alert(this.secretencData);
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            var random = Math.random();
            this.datadetail = [];
            await mainAPIDataSingel.get("parastapainnovationfinance-GetIDFinance?id=" + terpilih + "&random=" + random + "&project_id=" + this.project_id + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;
                    this.Komponen = Response.data.content.data[0].Komponen;
                    this.SubKomponen = Response.data.content.data[0].SubKomponen;
                    this.kendala = Response.data.content.data[0].kendala;
                    this.tindaklanjut = Response.data.content.data[0].tindaklanjut;
                    var id_userpmis = Response.data.content.data[0].id_user;
                    this.defaultSelectedid_user = {
                        code: Response.data.content.data[0].id_user,
                        label: Response.data.content.data[0].nama_satker,
                        tag: Response.data.content.data[0].id_user,
                    };
                    this.selectedid_user = Response.data.content.data[0].id_user;

                    if (this.selectedid_user != '') {
                        mainAPIDataSingelcari.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                            Response => {
                                this.datapesan = Response.data.message;
                                //alert(this.datapesan);
                                if (this.datapesan == 'data diketemukan') {
                                    this.datasatker = [];
                                    this.satker = [];
                                    this.datasatker = Response.data.content.data;
                                    this.datasatker.forEach((item) => {
                                        this.satker.push({
                                            label: item.namasatker,
                                            code: this.datasatker.indexOf(item) + 1,
                                            tag: item.kodesatker,
                                        });
                                    });
                                    this.satker.unshift({
                                        label: 'Pilih Salah Satu',
                                        code: 0,
                                        tag: '0',
                                    });
                                }
                                this.halamanloading = false;
                            }
                        ).catch(error => {
                            console.log(error);
                            //this.ClearlocalStorage();
                            this.halamanloading = false;
                        });
                    }

                    var satkerpmis = Response.data.content.data[0].satker;
                    if (satkerpmis != '') {
                        this.defaultSelectedsatker = {
                            code: Response.data.content.data[0].satker,
                            label: Response.data.content.data[0].namasatker,
                            tag: Response.data.content.data[0].satker,
                        };
                        this.selectedsatker = Response.data.content.data[0].satker;
                    }

                    this.defaultSelectedjenispekerjaan = {
                        code: Response.data.content.data[0].tipe_work,
                        label: Response.data.content.data[0].Kategori,
                        tag: Response.data.content.data[0].tipe_work,
                    };
                    this.defaultSelectedbankreview = {
                        code: Response.data.content.data[0].BankReview,
                        label: Response.data.content.data[0].namaBankReview,
                        tag: Response.data.content.data[0].BankReview,
                    };
                    this.defaultSelectedStatus_pekerjaan = {
                        code: Response.data.content.data[0].idstatuspekerjaan,
                        label: Response.data.content.data[0].Status_pekerjaan,
                        tag: Response.data.content.data[0].idstatuspekerjaan,
                    };
                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    this.selectedbankreview = Response.data.content.data[0].BankReview;
                    this.selectedStatus_pekerjaan = Response.data.content.data[0].idstatuspekerjaan;
                    //alert(Response.data.content.data[0].id_pmis);

                    document.getElementById('Penyedia').value = Response.data.content.data[0].KONTRAKTOR;
                    document.getElementById('Mulai').value = Response.data.content.data[0].MULAI;
                    document.getElementById('Selesai').value = Response.data.content.data[0].SELESAI;
                    document.getElementById('Kontrak').value = Response.data.content.data[0].NOKONTRAK;
                    document.getElementById('Nilai').value = this.G_numFormat(Response.data.content.data[0].NILAIKONTRAK);

                    document.getElementById('Adendum').value = Response.data.content.data[0].ADENDUM;
                    //this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.OWP = this.G_numFormat(Response.data.content.data[0].OWP);
                    this.AWP = Response.data.content.data[0].AWP;
                    this.DIPA = Response.data.content.data[0].DIPA;
                    this.REALISASI = Response.data.content.data[0].REALISASI;
                    this.Capaian = Response.data.content.data[0].PROGRES;
                    this.koderegister = Response.data.content.data[0].register;
                    this.halamanloading = false;

                    this.datadetail = Response.data.content.data[0].detail;
                }
            ).catch(error => {
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        cekvalidasitahapan(kode) {
            //alert(kode);
            var arraycek = [];
            for (let x = 0; x < this.tahapanpekerjaan.length; x++) {
                for (let i = 0; i < this.tahapanpekerjaan[x].tahapan.length; i++) {
                    //alert(x-1);
                    arraycek.push(this.tahapanpekerjaan[x].tahapan[i].id);
                }
            }
            var index = arraycek.indexOf(kode);
            //alert(index);
            if (index > 0) {
                if (document.getElementById('Status_pekerjaan_' + arraycek[index - 1]).checked == false) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Silahkan pilih terlebih dahulu tahapan sebelumnya..',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById('Status_pekerjaan_' + kode).checked = false;
                }
            }
        },
        cektanggal(kode) {
            var tanggal = new Date(document.getElementById('Mulai' + kode).value);
            var sdtanggal = new Date(document.getElementById('Selesai' + kode).value);
            if (tanggal > sdtanggal) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal Mulai Tidak Boleh Lebih Besar..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
        },
        validasidata() {
            this.validasi = true;
            return;
        },
        update() {
            if (this.datadetail.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Masukkan data DIPA.',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }

            var ba = '';
            var baes1 = '';
            var akun = '';
            var program = '';
            var kegiatan = '';
            var kdoutput = '';
            var kewenangan = '';
            var sumber_dana = '';
            var lokasi = '';
            var budget_type = '';
            var amount = '';
            var cara_tarik = '';
            var kdregister = '';
            var filenya_dipa = '';

            for (let i = 0; i < this.datadetail.length; i++) {
                if (i == 0) {
                    ba = ba + document.getElementById('ba' + (i + 1)).value;
                    baes1 = baes1 + document.getElementById('baes1' + (i + 1)).value;
                    akun = akun + document.getElementById('akun' + (i + 1)).value;
                    program = program + document.getElementById('program' + (i + 1)).value;
                    kegiatan = kegiatan + document.getElementById('kegiatan' + (i + 1)).value;
                    kdoutput = kdoutput + document.getElementById('kdoutput' + (i + 1)).value;
                    kewenangan = kewenangan + document.getElementById('kewenangan' + (i + 1)).value;
                    sumber_dana = sumber_dana + document.getElementById('sumber_dana' + (i + 1)).value;
                    lokasi = lokasi + document.getElementById('lokasi' + (i + 1)).value;
                    budget_type = budget_type + document.getElementById('budget_type' + (i + 1)).value;
                    amount = amount + document.getElementById('amount' + (i + 1)).value;
                    cara_tarik = cara_tarik + document.getElementById('cara_tarik' + (i + 1)).value;
                    kdregister = kdregister + document.getElementById('kdregister' + (i + 1)).value;
                    filenya_dipa = filenya_dipa + document.getElementById('filenya_dipa' + (i + 1)).value;
                }
                else {
                    ba = ba + '|' + document.getElementById('ba' + (i + 1)).value;
                    baes1 = baes1 + '|' + document.getElementById('baes1' + (i + 1)).value;
                    akun = akun + '|' + document.getElementById('akun' + (i + 1)).value;
                    program = program + '|' + document.getElementById('program' + (i + 1)).value;
                    kegiatan = kegiatan + '|' + document.getElementById('kegiatan' + (i + 1)).value;
                    kdoutput = kdoutput + '|' + document.getElementById('kdoutput' + (i + 1)).value;
                    kewenangan = kewenangan + '|' + document.getElementById('kewenangan' + (i + 1)).value;
                    sumber_dana = sumber_dana + '|' + document.getElementById('sumber_dana' + (i + 1)).value;
                    lokasi = lokasi + '|' + document.getElementById('lokasi' + (i + 1)).value;
                    budget_type = budget_type + '|' + document.getElementById('budget_type' + (i + 1)).value;
                    amount = amount + '|' + document.getElementById('amount' + (i + 1)).value;
                    cara_tarik = cara_tarik + '|' + document.getElementById('cara_tarik' + (i + 1)).value;
                    kdregister = kdregister + '|' + document.getElementById('kdregister' + (i + 1)).value;
                    filenya_dipa = filenya_dipa + '|' + document.getElementById('filenya_dipa' + (i + 1)).value;
                }
            }

            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            var kodesatker = this.selectedsatker;
            //alert(terpilih);
            //return
            var fd = new FormData();
            fd.append("idkegiatan", terpilih);
            fd.append("kodesatker", kodesatker);
            fd.append("ba", ba);
            fd.append("baes1", baes1);
            fd.append("akun", akun);
            fd.append("program", program);
            fd.append("kegiatan", kegiatan);
            fd.append("kdoutput", kdoutput);
            fd.append("kewenangan", kewenangan);
            fd.append("sumber_dana", sumber_dana);
            fd.append("lokasi", lokasi);
            fd.append("budget_type", budget_type);
            fd.append("amount", amount);
            fd.append("cara_tarik", cara_tarik);
            fd.append("kdregister", kdregister);
            fd.append("filenya_dipa", filenya_dipa);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            mainAPI.post("mappingdipa_emon-Add", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Finance/" + kode);
                            //swal.fire('Peringatan', Response.data.message, 'success');
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
        //alert(this.secretencData);
    }
}
</script>
<style></style>